module.exports = __webpack_public_path__ + "static/media/wheelBearing.b0fbe152.svg";